import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('FlightTravelPolicyModel')
export default class FlightTravelPolicyModel {
  @JsonProperty('max_price', Number, true) public maxPrice: number = undefined;
  @JsonProperty('haul', String, true) public haul: string = undefined;
  @JsonProperty('comfort_class', String, true) public comfortClass: string = undefined;
}
